import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./Badge.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                          */
//#region src/shared/Badge.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-2a7101e8"]]);
//#endregion
export { n as default };

//# sourceMappingURL=Badge.vue.js.map